import AbstractService from 'core/abstracts/AbstractService';
// Facade
import Facade from 'core/Facade';

class SiteService extends AbstractService {

    getSites() {
        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/sites?ps=2500&p=1&sort=alpha_asc',
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    sites: await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    getSite(id) {
        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/sites' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    addSite(options) {
        const site = {
            name: options.name,
            url: options.url,
            lat: options.lat,
            long: options.long,
            proxy_type: options.proxyType,
            proxy_country: options.proxyCountry,
            color: options.color,
            comment: options.comment,
            alternative_urls: options.alternativeUrls,
            img_url: options.imgUrl,
        };

        site.is_market_place = options.speConfig ? options.speConfig.isMarketplace : false;
        site.trust_alert_threshold = options.speConfig ? options.speConfig.trustAlertThreshold : 0.01;
        site.robot_version = options.speConfig ? options.speConfig.robot : 'V3';

        if (!Facade.isEmpty(options.speConfig)) {
            site.spe_config = {
                is_market_place: options.speConfig.isMarketplace,
                trust_alert_threshold: options.speConfig.trustAlertThreshold,
                robot: options.speConfig.robot,
                tax: options.speConfig.tax,
                currency: options.speConfig.currency,
                bw_ref: options.speConfig.bwRef,
                bw_config: options.speConfig.bwConfig,
                comment: options.speConfig.comment,
                max_parallel_workers: options.speConfig.maxParallelWorkers,
                scraping_control_duration: options.speConfig.scrapingControlDuration
            };
        } else {
            site.spe_config = options.speConfig;
        }

        if (!Facade.isEmpty(options.sliderConfig)) {
            site.slider_config = {
                url: options.sliderConfig.url,
                query: options.sliderConfig.query,
                img_list_tag: options.sliderConfig.imgListTag,
                info_tag: options.sliderConfig.infoTag,
                name_tag: options.sliderConfig.nameTag,
                url_tag: options.sliderConfig.urlTag,
                title_tag: options.sliderConfig.titleTag,
                alt_tag: options.sliderConfig.altTag
            };
        } else {
            site.slider_config = options.sliderConfig;
        }

        if (!Facade.isEmpty(options.adboxConfig)) {
            site.adbox_config = {
                sender_mails: options.adboxConfig.senderMails
            };
        }

        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + 'bo/sites',
            json: site
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    updateSite(options, id) {

        const site = {
            lat: options.lat,
            long: options.long,
            proxy_type: options.proxyType,
            proxy_country: options.proxyCountry,
            color: options.color,
            comment: options.comment,
            alternative_urls: options.alternativeUrls,
            img_url: options.imgUrl
        };

        site.is_market_place = options.speConfig ? options.speConfig.isMarketplace : false;
        site.trust_alert_threshold = options.speConfig ? options.speConfig.trustAlertThreshold : 0.01;
        site.robot_version = options.speConfig ? options.speConfig.robot : 'V3';

        if (!Facade.isEmpty(options.speConfig)) {
            site.spe_config = {
                is_market_place: options.speConfig.isMarketplace,
                trust_alert_threshold: options.speConfig.trustAlertThreshold,
                robot: options.speConfig.robot,
                tax: options.speConfig.tax,
                currency: options.speConfig.currency,
                bw_ref: options.speConfig.bwRef,
                bw_config: options.speConfig.bwConfig,
                comment: options.speConfig.comment,
                max_parallel_workers: options.speConfig.maxParallelWorkers,
                scraping_control_duration: options.speConfig.scrapingControlDuration
            };
        } else {
            site.spe_config = options.speConfig;
        }

        if (!Facade.isEmpty(options.sliderConfig)) {
            site.slider_config = {
                url: options.sliderConfig.url,
                query: options.sliderConfig.query,
                img_list_tag: options.sliderConfig.imgListTag,
                info_tag: options.sliderConfig.infoTag,
                name_tag: options.sliderConfig.nameTag,
                url_tag: options.sliderConfig.urlTag,
                title_tag: options.sliderConfig.titleTag,
                alt_tag: options.sliderConfig.altTag,
                robot: options.sliderConfig.robot
            };
        } else {
            site.slider_config = options.sliderConfig;
        }

        if (!Facade.isEmpty(options.adboxConfig)) {
            site.adbox_config = {
                sender_mails: options.adboxConfig.senderMails
            };
        }

        return this.request({
            method: 'PUT',
            url: Facade.getApiRoot() + 'bo/sites/' + id,
            json: site
        }).then(responseData => {
            if (responseData.ok) {
                return responseData;
            }
            throw responseData;
        });
    }

    deleteSite(id) {
        return this.request({
            method: 'DELETE',
            url: Facade.getApiRoot() + 'bo/sites/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData;
            }
            throw responseData;
        });
    }
}

export default new SiteService();
